import React from 'react';
import { HashRouter as Router, Routes, Route, Link } from 'react-router-dom';
import FloatingBot from './components/FloatingBot';
import Home from './pages/Home';
import HostGuide from './pages/HostGuide';
import AdvertGuide from './pages/AdvertGuide';

const LOGO_URL = 'https://i.postimg.cc/bJDWFPtK/unnamed.png';
const TELEGRAM_LINK = 'https://t.me/sc4apps';

function App() {
  return (
    <Router>
      <div className="min-h-screen bg-[#0A0A0B] text-slate-200 font-sans selection:bg-yellow-500/30">
        <FloatingBot />
        <nav className="fixed top-0 w-full z-50 bg-[#0A0A0B]/80 backdrop-blur-md border-b border-white/5">
          <div className="max-w-7xl mx-auto px-6 h-20 flex items-center justify-between">
            <Link to="/" className="flex items-center gap-3">
              <img src={LOGO_URL} alt="SC4APPS Logo" className="h-10 w-10 object-contain rounded-lg" />
              <span className="text-white font-black tracking-tighter text-xl hidden sm:block">SC4APPS</span>
            </Link>
            <div className="flex items-center gap-6">
              <a href={TELEGRAM_LINK} target="_blank" rel="noreferrer" className="px-6 py-2.5 rounded-full bg-yellow-500 hover:bg-yellow-400 text-black font-black text-sm transition-all duration-300 shadow-[0_0_20px_-5px_rgba(234,179,8,0.5)]">
                ORDER NOW
              </a>
            </div>
          </div>
        </nav>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/host-apk" element={<HostGuide />} />
          <Route path="/advert-guide" element={<AdvertGuide />} />
        </Routes>
        <footer className="py-16 border-t border-white/5 text-center px-6">
          <img src={LOGO_URL} alt="Logo" className="h-12 mx-auto mb-8 opacity-40 grayscale hover:grayscale-0 hover:opacity-100 transition-all duration-500" />
          <p className="text-slate-600 text-xs tracking-widest uppercase font-bold">
            © {new Date().getFullYear()} SC4APPS. All rights reserved.
          </p>
        </footer>
      </div>
    </Router>
  );
}

export default App;